export default {"src":"/_next/static/image/src/images/Footer/dog-with-food-hat.3088a1b2b92c48fb0c9ba513a6293d00.svg","height":81,"width":72};